import { CreateButton, TopToolbar } from 'react-admin';
import { SortButton } from './SortButton';

export const ListActions = ({ sortOptions }: { sortOptions?: any }) => {
	return (
		<TopToolbar sx={{ minHeight: '30px', alignItems: 'stretch', px: 0, py: 1 }}>
			{sortOptions?.length > 0 && <SortButton options={sortOptions} />}
			<CreateButton size="small" variant="contained" to="create" />
		</TopToolbar>
	);
};
